import { render, staticRenderFns } from "./InfoListInput.vue?vue&type=template&id=2c9a63db"
var script = {}
import style0 from "./InfoListInput.vue?vue&type=style&index=0&id=2c9a63db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports